import React, { useState } from 'react'
import { useSnackbar } from "../snackbar/snackbar"
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import styles from './styles.module.css'
import BaseForm from "../base-form/base-form"
import Button from '../nura/button/button'

import { StandardInput } from './run-blueprint'
import { CircularProgress } from '@mui/material'
import { submitFeedback } from '../../api-client/data'


const FeedbackForm = ({ onSubmit, onClose }) => {
    const localOnSubmit = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target)
        const formValues = Object.fromEntries(formData.entries())

        if (formValues?.message?.length === 0) {
            return
        }

        onSubmit(formValues)
    }

    return (
        <Card variant="modal" style={{ width: 350, height: 'auto' }}>
            <BaseForm onBack={onClose} title="Submit Feedback">
                <form onSubmit={localOnSubmit}>
                    <StandardInput name="Feedback Type">
                        <select name="type">
                            <option>Bug</option>
                            <option>Feature Request</option>
                            <option>Other</option>
                        </select>
                    </StandardInput>
                    <StandardInput name="Message">
                        <textarea rows={5} name="message" style={{ border: '1px solid var(--border-secondary)', padding: 5, color: 'var(--text-primary)', borderRadius: 10}} className={styles.textArea} />
                    </StandardInput>
                    
                    <div style={{ paddingTop: 20, paddingBottom: 5, display: 'flex' }}>
                        <Button variant="primary" type="submit" style={{ width: '100%'}}>Submit</Button>
                    </div>
                </form>
            </BaseForm>
        </Card>
    )
}

export default ({ onClose, show }) => {
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const onSubmit = async (values) => {
        setLoading(true)

        try {
            await submitFeedback(values)
            enqueueSnackbar("Feedback Submitted! Thank you!", { variant: "info" })
        } catch {
            enqueueSnackbar("Could not submit feedback - try again later", { variant: "error" })
        }

        setLoading(false)
        onClose()
    }

    return (
        <Modal show={show} style={{ minWidth: 358, height: 'auto', maxWidth: 800 }} onClose={onClose}>
            {
                loading === true ? (
                    <CircularProgress />
                ) : (
                    <FeedbackForm onSubmit={onSubmit} onClose={onClose}/>
                )
            }
        </Modal>
    )
}